export const TITLES = {
  TORRENS: 4,
};
